import { render, staticRenderFns } from "./DataAirList.vue?vue&type=template&id=bf69a0bc&scoped=true"
import script from "./DataAirList.vue?vue&type=script&lang=js"
export * from "./DataAirList.vue?vue&type=script&lang=js"
import style0 from "./DataAirList.vue?vue&type=style&index=0&id=bf69a0bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf69a0bc",
  null
  
)

export default component.exports